"use client";

import "./clinic-blog.scss";
import Link from "next/link";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
export default function ClinicBlog({ clinicBlogs }) {
  // function getFirstWordsFromHTML(htmlContent, wordCount) {
  //   // Create a temporary element to strip HTML tags
  //   const tempElement = document.createElement("div");
  //   tempElement.innerHTML = htmlContent;
  //   const textContent = tempElement.textContent || tempElement.innerText || "";

  //   // Split the text content into words and join the first 'wordCount' words
  //   return textContent.split(/\s+/).slice(0, wordCount).join(" ");
  // }
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  return (
    <div>
      {clinicBlogs?.data?.length > 0 ? (
        <ul className="clinic-blog__list">
          {clinicBlogs.data.map((item) => {
            return item?.id ? (
              <li>
                <Link
                  href={"/blog/" + item?.slug}
                  prefetch={false}
                  className="clinic-blog__item"
                >
                  <h3
                    dangerouslySetInnerHTML={{ __html: item?.title }}
                    className="clinic-blog__title"
                  />
                  {/* <div
                    className="clinic-blog-content"
                    // dangerouslySetInnerHTML={{ __html: item?.content }}
                  >
                    {getFirstWordsFromHTML(item?.content, 50)}
                  </div> */}
                </Link>
              </li>
            ) : null;
          })}
        </ul>
      ) : (
        <div
          style={{
            color: "#2a3467",
            display: "flex",
            justifyContent: "center",
            fontSize: "16px",
            margin: "12px 0px",
          }}
        >
          Chưa có thông tin
        </div>
      )}
    </div>
  );
}
